module.exports = __webpack_public_path__ + "img/car2.9b663a9a.svg";